import { Typography } from '@mui/material';

import { CollapsibleSection } from '@eng-mono/atlassian/jira/mojira-bugtracker/frontend-feature-issue-list-collapsible-section'
import { JsmIssueBase } from '@eng-mono/atlassian/jira/mojira-bugtracker/util-issue-list-fe';

interface PeopleCollapseProps {
  issue: JsmIssueBase;
  expanded: boolean;
  toggleSection: () => void;
}

export function PeopleCollapse({ issue, expanded, toggleSection }: PeopleCollapseProps) {
  return (
    <CollapsibleSection title="People" expanded={expanded} setExpanded={toggleSection}>
      {/* <Typography sx={{ marginBottom: 2 }}>
        Reporter: {issue?.fields.reporter?.displayName || 'Unknown'}
      </Typography> */}
      <Typography sx={{ marginBottom: 2 }}>
        Votes: {issue?.fields.customfield_10070 || 0}
      </Typography>
      <Typography sx={{ marginBottom: 2 }}>
        Watchers: {issue?.fields.watchers?.watchCount || 0}
      </Typography>
    </CollapsibleSection>
  );
}
